import Clients from '@/admin/pages/clients/clients';
import { clientsQuery } from '@/admin/queries/clients';
import { sanitizeSearchParams } from '@/lib/utils';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/clients/')({
	validateSearch: (search) => sanitizeSearchParams(search),
	loaderDeps: ({ search }) => search,

	loader: ({ context, deps }) =>
		context.queryClient.ensureQueryData(
			clientsQuery({
				page: deps.page,
				per_page: deps.per_page,
				search: deps.search || undefined,
			}),
		),

	component: Clients,
});
